import * as React from 'react';
import {
  ISharedAppContext,
  SharedAppConsumer,
  SharedAppProvider,
} from '@origin-digital/shared-app-context';

const SharedAppContextPage: React.FC = () => (
  <>
    <SharedAppProvider xhrInitialize={true}>
      <SharedAppConsumer>
        {(context: ISharedAppContext) => {
          return context.businessPartnerId ? (
            <div>
              <h1>Old context</h1>
              <p>BPID: {context.businessPartnerId}</p>
              <p>Premiseid: {context.premiseId}</p>
              <p />
              <p>properties:</p>
              {context.properties.map((a) => (
                <>
                  <p>|--premiseId: {a.premiseId}</p>
                  <p>|--addressId: {a.addressId}</p>
                  <p>|--premiseName: {a.premiseName}</p>
                  <p>|--premisePrimary: {a.premisePrimary}</p>
                  <p>|--state: {a.state}</p>
                  {a.contractAccounts.map((s) => (
                    <>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--contractAccountId: {s.contractAccountId}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--divisionCode: {s.divisionCode}</p>
                      <p>&nbsp;&nbsp;&nbsp;&nbsp;|--status: {s.status}</p>
                    </>
                  ))}
                </>
              ))}
            </div>
          ) : (
            <div>
              <h1>Old context</h1>
              <p>no bpid</p>
            </div>
          );
        }}
      </SharedAppConsumer>
    </SharedAppProvider>
  </>
);

export { SharedAppContextPage };
